/* eslint-disable */

/**
 * equal function originally comes from https://github.com/epoberezkin/fast-deep-equal
 * has been modified to suit our needs
 */
const isArray = Array.isArray;
const keyList = Object.keys;
const hasProp = Object.prototype.hasOwnProperty;
export function equal(a, b, config = {}) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      
      if (config.ignoreArrayOrder) {
        for (i = length; i-- !== 0;)
          if (!b.some(item => equal(item, a[i], config))) return false;
      } else {
        for (i = length; i-- !== 0;)
          if (!equal(a[i], b[i], config)) return false;
      }
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (!equal(a[key], b[key], config)) return false;
    }

    return true;
  }

  return a !== a && b !== b;
};


// WEBPACK FOOTER //
// ./src/services/jsonEqualityService.js